import { LocalDate } from '@js-joda/core';

import { BindingCreator } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

const COMPLETION_DATE_FIELD_NAME = 'completionDate';

export type GynecologicalInterviewPregnancyCompletionFormBeanPart = {
   [COMPLETION_DATE_FIELD_NAME]: LocalDate | null;
};

export type GynecologicalInterviewPregnancyCompletionFormPartProps = {
   readonly register: BindingCreator<
      GynecologicalInterviewPregnancyCompletionFormBeanPart,
      typeof COMPLETION_DATE_FIELD_NAME
   >;
};

export const GynecologicalInterviewPregnancyCompletionFormPart = (
   props: GynecologicalInterviewPregnancyCompletionFormPartProps
): JSX.Element => {
   return (
      <>
         <DatePicker
            testId={'pregnancyCompletionDate'}
            controller={props.register(COMPLETION_DATE_FIELD_NAME)}
            label={gynecologicalInterviewTranslationKeys.pregnancyCompletionDate}
            dayValidators={'dayAfterToday'}
         />
      </>
   );
};
